import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, Validators, UntypedFormGroup, UntypedFormControl, UntypedFormBuilder } from '@angular/forms';
import { SettingsModel } from '../../models/settings.model';
import { SettingsService } from '../../services/settings.service';
import { NexusComponent } from 'app/core/components/nexus/nexus.component';
import * as moment from 'moment';
import { NexusFormResultModel } from 'app/core/models/nexus-form-result.model';
import { ChangePasswordModel } from 'app/models/change-password.model';
import { TutorialService } from '../../services/tutorial.service';
import { faTimesCircle, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { MustMatch } from 'app/core/validators/must-match.validator';
import { PasswordStrengthValidator } from 'app/core/validators/password-strengh.validator';
@Component({
    selector: 'app-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.scss'],
    standalone: false
})
export class SettingsComponent extends NexusComponent implements OnInit {
    public settings_model: SettingsModel;
  public change_password: ChangePasswordModel = new ChangePasswordModel();
  faTimesCircle =faTimesCircle;
  faCheckCircle =faCheckCircle;
    public profile_result_model: NexusFormResultModel = new NexusFormResultModel();

  public opened = false;

    public profile_form = new UntypedFormGroup({
        phone: new UntypedFormControl({ value: '', disabled: true }),
        secondary_phone: new UntypedFormControl('', this.ValidateOptionalPhone),
        email: new UntypedFormControl({ value: '', disabled: true }, this.ValidateEmail),
        secondary_email: new UntypedFormControl('', this.ValidateOptionalEmail)
    });

    public password_result_model: NexusFormResultModel = new NexusFormResultModel();
    public password_form:UntypedFormGroup;

  constructor(private route: ActivatedRoute, private router: Router, private settings_service: SettingsService, private tutorial_service: TutorialService, private formBuilder: UntypedFormBuilder) {
    super();
  }

    ngOnInit() {

      this.password_form = this.formBuilder.group({
        current_password: new UntypedFormControl('', Validators.required),
        new_password: ['', [Validators.required,PasswordStrengthValidator()]],
        confirm_password: ['', Validators.required]
      },
        {
          validator: MustMatch('new_password', 'confirm_password')
        });



        this.route.data.subscribe(({ settings_model }) => {
            this.settings_model = settings_model;

            this.profile_form.patchValue(this.settings_model.profile);


        });

        this.profile_form.valueChanges.subscribe((form: any) => {
            this.PopulateModelFromForm(form, this.settings_model.profile);
        });

        this.password_form.valueChanges.subscribe((form: any) => {
            this.PopulateModelFromForm(form, this.change_password);
        });

    }

    get showPasswordErrors() {
      if(this.password_form?.controls?.new_password?.errors?.required === true ){
        return false;
      }
      return !(this.password_form?.controls?.new_password?.errors == null);
    }
    get passwordErrors() {
        return this.password_form?.controls?.new_password.errors?.password_strength || {};
    }
    get confirmPasswordErrors() {
      return (this.password_form?.controls?.confirm_password?.errors == null);

    }
    get showConfirmPasswordErrors() {
      return !this.password_form?.controls?.confirm_password?.errors?.required;
    }

    saveProfile(event) {
        this.profile_result_model.Reset();

        this.StartSpinner();
        this.settings_service.PutProfile(this.settings_model.profile).subscribe(
            data => {
                this.settings_model = data;
                this.StopSpinner();
                this.profile_result_model.Success('Profile saved!');
            },
            err => {
                this.profile_result_model.Error(err);
                this.StopSpinner();
            });
    }

    changePassword(event) {
        if (this.password_form.invalid) {
            this.password_result_model.Incomplete();
            return;
        }



        this.password_result_model.Reset();
        this.StartSpinner();
        this.settings_service.ChangePassword(this.change_password).subscribe(
            data => {
                this.settings_model = data;
                this.StopSpinner();
                this.password_result_model.Success('Password changed successfully!');
            },
            err => {
                this.password_result_model.Error(err);
                this.StopSpinner();
            });

  }

  openDialog(): void {
    this.tutorial_service.openTutorial(this.settings_model.profile?.resident_portal_tutorial_url);
  }
}


